import React from 'react';
import ServiceSelection from '../components/ConnectorSettings/ServiceSelection';

function ServiceSelectionContainer() {
  return <ServiceSelection />;
}

export default ServiceSelectionContainer;
